const createDateObject = (date) => {
  if (date instanceof Date) return date;
  return new Date(date);
};

export const formatDate = (date) => {
  if(!date) return;
  const dateObject = createDateObject(date);
  return`${dateObject.getDate()}/${dateObject.getMonth()+1}/${dateObject.getFullYear()}`;
};

export const formatTime = (date) => {
  if(!date) return;
  const dateObject = createDateObject(date);
  return`${("0" + dateObject.getHours()).slice(-2)}u${("0" + dateObject.getMinutes()).slice(-2)}`;
};

export const formatDateTime = (date) => {
  if(!date) return;
  const dateObject = createDateObject(date);

  return `${formatDate(dateObject)} ${formatTime(dateObject)}`;
}

export const isoWithoutZone = (date) => {
  if(!date) return;
  const dateObject = createDateObject(date);
  //remove timezone offset
  const isoDateTime = new Date(dateObject.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
  return isoDateTime.slice(0, -5);
}

export const startOfdayMinuteOffset = (date, offset) => {
  if(!date) date = new Date();
  const dateObject = createDateObject(date);
  if(offset) {
    dateObject.setHours(0, offset, 0,0,0);
  }
  return dateObject;
}
